module.exports = __webpack_public_path__ + "static/FakedesOutline-ca287dc9b01576d2c3ac2043c65f4d07.ttf";